<template>
  <div class="main-page">
    <div class="logo-center">
      <img src="/logo.png" alt="" class="logo">
    </div>
  </div>
</template>

<script>
export default {
  name: "mainPage"
};
</script>

<style lang="scss">
.main-page {
  position: relative;
  height: 100%;
  background-color: transparent;
  .logo-center {
      color: #fff;
      height: 100vh;
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
    .logo {
      width: 250px;
    }
    h1 {
      margin-top: 15px;
      font-size: 24px;
      font-weight: bold;
    }
  }
}
</style>
